<div class="main-div"></div>
<div class="overlay" *ngIf="loading">
    <div class="center">
        <mat-spinner class="custom-spinner"></mat-spinner>
    </div>
</div>

<div class="login-wrapper">
    <mat-card class="login-card">
        <mat-card-content>
            <div class="maintenance-message">
                {{ message }}
            </div>
            <mat-card-actions class="login-actions">
                <button mat-raised-button
                        type="button"
                        color="primary"
                        class="full-width"
                        (click)="onRefresh()">
                    Refresh
                </button>
            </mat-card-actions>
        </mat-card-content>
    </mat-card>
</div>
